// @ts-check
import React from "react";
import classNames from "classnames";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
//import 'components/icons/Icons.scss';

/**
 * @typedef {import('preact').JSX.Element} JSXElement
 * @typedef {import('preact').JSX.HTMLAttributes<HTMLElement>} HTMLAttributes
 */

/**
 * @typedef {HTMLAttributes & { iconClassName?: string }} IconProps
 */

/** @param {IconProps} props @returns {JSXElement} */
const IconUpCaret = (props) => (
  <i className="csw-i csw-i-up-caret" aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconDownCaret = (props) => (
  <i className="csw-i csw-i-down-caret" aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconRightCaret = (props) => (
  <i className="csw-i csw-i-right-caret" aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconLeftCaret = (props) => (
  <i className="csw-i csw-i-left-caret" aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconCheck = (props) => (
  <i className={classNames("csw-i csw-i-check", props.iconClassName)} aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconCSLogo = (props) => (
  <i className="csw-i csw-i-cs-logo" aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconCSLogoDark = (props) => (
  <i className="csw-i csw-i-cs-logo-dark" aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconHeadHeart = (props) => (
  <i className="csw-i csw-i-headheart" aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconMedia = (props) => (
  <i className="csw-i csw-i-media" aria-hidden="true" {...props}>
    {" "}
  </i>
);

/** @param {IconProps} props @returns {JSXElement} */
const IconFlag = (props) => (
  <i className={classNames("csw-icon csw-icon-flag", props.iconClassName)} aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconClose = (props) => (
  <i className={classNames("csw-icon csw-icon-cross", props.iconClassName)} aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconGear = (props) => (
  <i className={classNames("csw-icon csw-icon-cog", props.iconClassName)} aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconMenu = (props) => (
  <i className={classNames("csw-icon csw-icon-menu-dots", props.iconClassName)} aria-hidden="true" {...props} />
);
/** @param {IconProps} props @returns {JSXElement} */
const IconShare = (props) => (
  <i className={classNames("csw-icon csw-icon-share", props.iconClassName)} aria-hidden="true" {...props} />
);
/** @param {IconProps} props @returns {JSXElement} */
const IconXTwitter = (props) => (
  <i className={classNames("csw-icon csw-icon-x-twitter", props.iconClassName)} aria-hidden="true" {...props} />
);
/** @param {IconProps} props @returns {JSXElement} */
const IconFacebook = (props) => (
  <i className={classNames("csw-icon csw-icon-facebook", props.iconClassName)} aria-hidden="true" {...props} />
);
/** @param {IconProps} props @returns {JSXElement} */
const IconLinkedIn = (props) => (
  <i className={classNames("csw-icon csw-icon-linkedin", props.iconClassName)} aria-hidden="true" {...props} />
);
/** @param {IconProps} props @returns {JSXElement} */
const IconInfo = (props) => (
  <i className={classNames("csw-i csw-icon-info", props.iconClassName)} aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconLock = (props) => (
  <i className={classNames("csw-i csw-i-lock", props.iconClassName)} aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconRadio = (props) => (
  <i className={classNames("csw-i csw-i-radio", props.iconClassName)} aria-hidden="true" {...props}>
    {" "}
  </i>
);
/** @param {IconProps} props @returns {JSXElement} */
const IconLightBulb = (props) => (
  <i className={classNames("csw-i csw-i-lightbulb", props.iconClassName)} aria-hidden="true" {...props}>
    {" "}
  </i>
);

export {
  IconCSLogo,
  IconCSLogoDark,
  IconUpCaret,
  IconDownCaret,
  IconRightCaret,
  IconCheck,
  IconClose,
  IconFlag,
  IconGear,
  IconInfo,
  IconFacebook,
  IconLeftCaret,
  IconLightBulb,
  IconHeadHeart,
  IconLinkedIn,
  IconLock,
  IconMedia,
  IconMenu,
  IconRadio,
  IconShare,
  IconXTwitter,
};
